<template>
  <div class="columns-select-group-item">
    <div class="columns-select-group-items__select-all">
      <MCheckbox
        :value="areAllChildrenSelected"
        :intermediate="someChildrenSelected"
        :disabled="false"
        :label-text="_getTr('select_all')"
        @input="selectAll"
      />
    </div>
    <div class="columns-select-group-items__items">
      <ColumnsSelectColumnItem
        v-for="item in items"
        :key="item.id"
        :selected-items="selectedItems"
        :item="item"
        :is-searching="isSearching"
        @toggleItems="toggleItems"
      />
    </div>
  </div>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';
  import ColumnsSelectColumnItem
    from 'components/Data/TableSettings/TableSettingsModal/ColumnsSelect/ColumnsSelectColumnItem';
  export default {
    name: 'ColumnsSelectGroupItem',
    components: {ColumnsSelectColumnItem, MCheckbox},
    props: {
      items: {
        type: Array,
        required: true
      },
      selectedItems: {
        type: Array,
        default: Array
      },
      isSearching: {
        type: Boolean,
        default: false
      },
      childIds: {
        type: Array,
        required: true
      },
      enabledChildIds: {
        type: Array,
        required: true
      },
      someChildrenSelected: {
        type: Boolean,
        required: true
      },
      areAllChildrenSelected: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      selectAll (status) {
        this.$emit('toggleItems', {status, itemIds: this.enabledChildIds});
      },
      toggleItems (payload) {
        this.$emit('toggleItems', payload);
      }
    }
  };
</script>

<style>
  .columns-select-group-item {
    font-size: 14px;
    margin-top: 8px;
  }
</style>
